module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/Third_criterium-contrast-0c40d4fd72e8175473c7006f5eeb406f.svg";